/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A4Inputs */

const es_marketplace_seo_galicia_faq_a4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De mayo a octubre el clima es más estable y hay más oferta. Primavera y septiembre ofrecen menos aglomeración en islas como Sálvora y Cíes.`)
};

const gl_marketplace_seo_galicia_faq_a4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De maio a outubro o clima é máis estable e hai máis oferta. Primavera e setembro ofrecen menos aglomeración en illas como Sálvora e Cíes.`)
};

const en_marketplace_seo_galicia_faq_a4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May to October is more stable with more supply. Spring and September mean fewer crowds on islands like Sálvora and Cíes.`)
};

/**
* | output |
* | --- |
* | "May to October is more stable with more supply. Spring and September mean fewer crowds on islands like Sálvora and Cíes." |
*
* @param {Marketplace_Seo_Galicia_Faq_A4Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a4 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A4Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A4Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a4(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a4(inputs)
	return es_marketplace_seo_galicia_faq_a4(inputs)
});